"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ProspectRecorder_1 = __importDefault(require("./ProspectRecorder"));
const PreviewKeyGate_1 = require("./PreviewKeyGate");
const pagePrompts = (page) => [
    { id: `page-like-${page}`, icon: '👍', label: 'What works', question: `What do you like on the ${page} page?` },
    { id: `page-change-${page}`, icon: '✏️', label: 'What you’d change', question: `What would you change on the ${page} page - wording, photos, layout?` },
    { id: `page-missing-${page}`, icon: '🧩', label: 'Anything missing', question: `Is anything missing from the ${page} page that your customers would look for?` },
    { id: `page-other-${page}`, icon: '💭', label: 'Anything else', question: `Any other thoughts while you’re on the ${page} page?` },
];
function SiteThoughts({ apiBaseUrl, businessId, pageName }) {
    const [key, setKey] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setKey(businessId ? (0, PreviewKeyGate_1.readStoredPreviewKey)(businessId) : null);
    }, [businessId, pageName]);
    if (!businessId || !key)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { style: { borderTop: '1px solid var(--line, #eee)', background: 'var(--paper, #fafafa)', padding: '8px 0 24px' }, children: (0, jsx_runtime_1.jsx)(ProspectRecorder_1.default, { apiBaseUrl: apiBaseUrl, publicBaseUrl: apiBaseUrl.replace(/\/api\/v1$/, ''), businessId: businessId, previewKey: key, prompts: pagePrompts(pageName), title: `💭 Your thoughts on the ${pageName} page`, subtitle: "Tap a card and type your answer - it comes straight to us. Rather talk? Press \uD83C\uDF99 Talk us through it (bottom left): it keeps recording as you move between pages.", hideDeviceCue: true, typeOnly: true }) }));
}
exports.default = SiteThoughts;
